import { z } from "zod";

export const brandNameSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type BrandName = z.infer<typeof brandNameSchema>;
